export default __webpack_public_path__ + "static/media/display.a6bf0fc6.svg";